import { useEffect } from "react";
import SuccessCouponCodeImage from "../../../img/success-coupon-code.png";

const SuccessCouponCode = ({
  onClose,
  amountSaved,
  couponCode,
}) => {

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  
  return (
    <div className="fixed inset-0 z-[9999] bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white py-5 px-[30px] sm:py-10 sm:px-[60px] rounded-[20px] w-[450px] text-center mx-5 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-black text-xl font-bold"
        >
          ✕
        </button>
        <img
          src={SuccessCouponCodeImage}
          alt="Success Pop Up"
          height={200}
          width={200}
          className="mx-auto mb-3"
        />
        <div className="text-[#4659CA] text-[24px] leading-[30px] font-semibold mb-1 font-gilroy-bold">
          You have saved upto ₹{amountSaved}
        </div>
        <div className="text-[#020617] text-[16px] leading-6 mb-1 font-gilroy">
          with this coupon code
        </div>
        <div className="text-[#020617] text-[16px] leading-6 mb-5 font-gilroy">
          Coupon code: “{couponCode}” Applied
        </div>
        <button
          className="text-[16px] leading-6 bg-[#4659CA] font-semibold text-white cursor-pointer py-2 px-8 rounded-[10px]"
          onClick={onClose}
        >
          Thanks
        </button>
      </div>
    </div>
  );
};

export default SuccessCouponCode;
